"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_CONTAINER_WIDTH = exports.ICON_CONTENT_MARGIN = exports.CONTAINER_X_PADDING = exports.ACTION_WIDTH = void 0;
var ACTION_WIDTH = 22;
exports.ACTION_WIDTH = ACTION_WIDTH;
var CONTAINER_X_PADDING = 8;
exports.CONTAINER_X_PADDING = CONTAINER_X_PADDING;
var ICON_CONTENT_MARGIN = 5;
exports.ICON_CONTENT_MARGIN = ICON_CONTENT_MARGIN;
var MAX_CONTAINER_WIDTH = 300;
exports.MAX_CONTAINER_WIDTH = MAX_CONTAINER_WIDTH;